
// @ts-ignore
const templates = import.meta.glob("@client/templates/*.tsx", {eager: true});

export const getTemplate = async ({template_name}: {template_name: string}) => {
    const templatePath = `/client/templates/${template_name}.tsx`;
    const TemplateModule = templates[templatePath] as {Template: React.ComponentType<any>}
    return TemplateModule.Template;
}
